let button = document.getElementById('scrollToTopButton');

button.addEventListener('click', function(){
    window.scrollTo({
        top: 0,
        behavior: 'smooth'  // これによりスクロールがなめらかになります
    });
});